import React from 'react';

import { Icon20ShoppingCartOutline } from '@vkontakte/icons';
import {
  Button,
  Spacing,
  Text,
  Title,
} from '@vkontakte/vkui';
import { AnimatePresence, motion } from 'framer-motion';

import styles from './index.module.css';
import { OthersPredictionBoxProps } from './types';
import { IconedText } from '../../../../../../../components/IconedText';
import { FRIEND_PREDICTION_PRICE } from '../../../../../../../constants/Common';

export const OthersPredictionBox: React.FC<OthersPredictionBoxProps> = ({ handleGetFriendTemperamentClick }) => {
  return (
    <div className={styles.optionContainer}>
      <div className={styles.upperBox}>
        <Title level="2" className={styles.title}>
                  Узнать профессиональный тип других
        </Title>
        <Spacing size={8}/>
        <Text className={styles.text}>
                  Оплатите голосами и узнайте, что страницы людей говорят об их профессиональном типе
        </Text>
        <Spacing size={45}/>
      </div>
      <Button
        onClick={handleGetFriendTemperamentClick}
        mode="primary"
        size="l"
      >
                Узнать профессиональный тип
      </Button>
      <Spacing size={25}/>
      <div className={styles.iconedTextContainer}>
        <IconedText
          icon={
            <AnimatePresence>
              <motion.div animate={{ x: [6, -4, 0] }} transition={{ duration: 0.3 }}>
                <Icon20ShoppingCartOutline className={styles.icon}/>
              </motion.div>
            </AnimatePresence>
          }
          text={(
            <span className={styles.iconedText}>
                    Проверка другого человека становится доступна после оплаты {FRIEND_PREDICTION_PRICE} голоса. В случае ошибки оплата голосов не будет произведена
            </span>
          )}
        />
      </div>
    </div>);
};
